import React, { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import break_box from '../../../../images/product/break_box.png';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css'; 
import { Link } from "react-router-dom"; 

const AddMenuItem = ({ show, onClose, selectedDate, selectedCategory, selectedProduct, selectedProductName }) => {
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
     const user_id = parseInt(localStorage.getItem("user_id"), 10);
     const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    // End Icon    

  const baseURL = process.env.REACT_APP_API_BASE_URL;   
  const [itemCategories, setItemCategories] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productImage, setProductImage] = useState(null);
  const defaultItemIdsForProduct2 = [1, 2, 3];

  useEffect(() => {
    if (show && selectedProduct && selectedDate) {
      setSelectedItems([]);
      const formattedDate = selectedDate.toLocaleDateString('sv-SE');

      axios
        .get(`${baseURL}/menumaker/products/grouped-by-product-item-category`, {
          params: {
            product_id: selectedProduct,
            menumaker_date: formattedDate,
          },
        })
        .then(res => {
          const response = res.data.data || {};
          const categories = response.item_categories || [];

          const normalized = categories.map(cat => ({
            ...cat,
            item_sub_categories: (cat.item_sub_categories || []).map(sub => ({
              ...sub,
              items: Array.isArray(sub.items) ? sub.items : Object.values(sub.items || {}),
            })),
          }));
          setItemCategories(normalized);
          setProductImage(response.product_image || null); 
          if (selectedProduct === 2) {
            setSelectedItems(defaultItemIdsForProduct2);
          }
        })
        .catch(err => {
          console.error(err);
          setItemCategories([]);
        });
    }
  }, [show, selectedProduct, selectedDate, baseURL]);

  const handleCheckboxChange = (itemId) => {
    if (selectedProduct === 2 && defaultItemIdsForProduct2.includes(itemId)) return;

    setSelectedItems(prev =>
      prev.includes(itemId)
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  const handleSubmit = async () => {
    if (!selectedCategory || !selectedDate || !selectedProduct || selectedItems.length === 0) return;

    const formattedDate = selectedDate.toLocaleDateString('sv-SE');

    const payload = {
      product_id: selectedProduct,
      productcategory_id: selectedCategory.value,
      menumaker_date: formattedDate,
      item_ids: selectedItems,
      branch_id,
      created_by:user_id    
    };

    try {
      setLoading(true);
      // await axios.post(`${baseURL}/menumaker`, payload);
      await axios.post(`${baseURL}/create-menumakers`, payload);
      onClose();
    } catch (err) {
      console.error(err);
      if (err.response?.data?.conflicting_items) {
        alert("Items already used:\n" + err.response.data.conflicting_items.join(', '));
      } else if (err.response?.data?.message) {
        alert(err.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const formatDateDay = () => {
    if (!selectedDate) return '';
    const options = { day: '2-digit', month: 'short', year: 'numeric', weekday: 'long' };
    return selectedDate.toLocaleDateString('en-IN', options);
  };

  const hasItems = itemCategories.some(cat =>
    cat.item_sub_categories?.some(sub => sub.items?.length > 0)
  );

  return (
    <Modal className="modal fade" show={show} size="lg" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Menu</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          <div className="row">
              <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                  <label className='text-gray-800 font-w500 fs-7'>Product Category</label>
                  <label className='text-danger fs-6 font-w500'>{selectedCategory?.label}</label>
              </div>
              <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                  <div className='d-flex flex-row gap-3 align-items-center justify-content-center'>
                      <LightGallery
                          onInit={onInit}
                          speed={500}
                          plugins={[lgThumbnail, lgZoom]} 
                      >
                          <div data-src={productImage || break_box} className='border rounded px-1 py-0'>
                              <img src={productImage || break_box} className='cursor-pointer w-45px h-45px' />
                          </div>
                      </LightGallery>
                      <div className='d-flex flex-column'>
                          <label className='text-gray-800 font-w500 fs-7'>Product</label>
                          <label className='text-danger fs-6 font-w500'>{selectedProductName}</label>
                      </div>
                  </div>
              </div>
              <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                  <label className='text-gray-800 font-w500 fs-7'>Date & Day</label>
                  <label className='text-danger fs-6 font-w500'>{formatDateDay()}</label>
              </div>
          </div>
 

          <label className="text-black fs-6 font-w500">Select Items</label>

          <div
            className="scroll-y mh-350px py-2"
            style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: '350px' }}
          >
            {!hasItems ? (
              <div className="text-muted">No items found for this product.</div>
            ) : (
              itemCategories.map(cat => (
                <div key={cat.item_category_id} className="mb-4">
                  <label className="fs-6 text-primary mb-1 font-w600">
                    {cat.item_category_name}
                  </label>

                  {(cat.item_sub_categories || []).map(sub => (
                    <div key={sub.item_sub_category_id} className="ms-3 mb-3">
                      <label className="fs-7 text-muted mb-1 font-w500">
                        {sub.item_sub_category_name}
                      </label>
                      <div className="row">
                        {(sub.items || []).map(item => (
                          <div key={item.item_id} className="col-lg-4">
                            <div className="form-check-inline mt-2">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                value={item.item_id}
                                checked={selectedItems.includes(item.item_id)}
                                disabled={
                                  selectedProduct === 2 &&
                                  defaultItemIdsForProduct2.includes(item.item_id)
                                }
                                onChange={() => handleCheckboxChange(item.item_id)}
                              />
                       
                               <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`tooltip-${item.item_id}`}>
                                      {item.item_name}
                                    </Tooltip>
                                  }
                                >
                                  <label className="fs-7 text-black mb-0 font-w500" style={{ cursor: 'pointer' }}>
                                    {item.item_name.length > 15
                                      ? `${item.item_name.slice(0, 15)}...`
                                      : item.item_name}
                                  </label>
                                </OverlayTrigger>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ))
            )}
          </div>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <Button className="btn btn-sm btn-primary" onClick={handleSubmit} disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Creating Menu Maker...
                </>
              ) : (
                <>
                  Create Menu Maker<i className="fas fa-angle-double-right ms-2" />
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddMenuItem;
